The event signaling that a hirer relationship has been added or removed.
